import { render, staticRenderFns } from "./Clicks.vue?vue&type=template&id=2995eb05&"
import script from "./Clicks.vue?vue&type=script&lang=ts&"
export * from "./Clicks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports